import { GET_SOCIAL_FEATURES, GET_SOCIAL_FEATURES_ERROR, ACKNOWLEDGE_BADGE_POPUP, TRACK_BADGE_SHARE } from '../actions/social-features';

// Initial state for social features
const initialState = {
  isLoading: false,
  error: null,
  data: null,
  shareHistory: []
};

/**
 * Reducer for social features data
 * Handles loading, error states, and data for social features
 *
 * @param {Object} state - Current state
 * @param {Object} action - Redux action
 * @returns {Object} - New state
 */
const socialFeaturesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOCIAL_FEATURES:
      return {
        ...state,
        isLoading: false,
        error: null,
        data: action.payload.data
      };

    case GET_SOCIAL_FEATURES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        data: null
      };

    case ACKNOWLEDGE_BADGE_POPUP:
      if (!state.data) return state;

      return {
        ...state,
        data: {
          ...state.data,
          showBadgePopup: false
        }
      };

    case TRACK_BADGE_SHARE:
      return {
        ...state,
        shareHistory: [
          ...state.shareHistory,
          {
            badgeId: action.payload.badgeId,
            platform: action.payload.platform,
            timestamp: new Date().toISOString()
          }
        ]
      };

    default:
      return state;
  }
};

export default socialFeaturesReducer;
